import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { useStyle } from "./Divider.style";
export var Divider = function() {
    var dividerStyles = useStyle().dividerStyles;
    return _jsx("div", {
        css: dividerStyles
    });
};
export default Divider;
